import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import anonymous from '../assets/anonymousPicture.png';
import boersen from '../assets/boersen.png';
import consulting from '../assets/consulting.jpg';
import creativeAgency from '../assets/creativeAgency.jpg';
import cranes from '../assets/cranes.jpg';
import management from '../assets/management.jpg';
import board from '../assets/board.jpg';
import sales from '../assets/sales.jpg';
import knowledge from '../assets/knowledge.jpg';
import customerService from '../assets/customer-service.jpg';
import bestyrelseskvinderLogo from '../assets/Bestyrelseskvinder-logo.png';

export const caseData = [
  {
    id: 1,
    slug: 'ai-discovery-kompetenceloeft',
    title: 'AI Discovery og kompetenceløft',
    company: 'Byggerådgiver (anonymiseret)',
    industry: 'Bygherrerådgivning',
    teaser: 'Strategisk AI-forløb med kompetenceløft, assistenter og køreplan på plads.',
    metrics: ['1.000+ timer sparet årligt', 'Kompetenceløft i hele organisationen', 'AI-assistenter sat i drift'],
    challenge:
      'Virksomheden manglede fælles retning, struktur og viden om, hvordan AI kunne understøtte kerneydelserne. Medarbejdere var nysgerrige men usikre på ansvarlig brug.',
    solution: [
      'Interviews og ledelsesworkshop for retning og governance',
      'Målrettet undervisning i ChatGPT for ledelse og hele medarbejderstaben',
      'Opsætning af AI-assistenter samt effektmåling på anvendelse, tid og kvalitet',
    ],
    results: [
      '1.000+ timer sparet årligt og højere kvalitet',
      'Tryg, ansvarlig og udbredt brug af AI på tværs af teams',
      'Strategisk AI-køreplan med prioriterede anvendelsescases og næste skridt',
    ],
    quote: {
      text: 'Et praksisnært AI-forløb der gav konkrete gevinster og en klar køreplan for næste skridt.',
      author: 'Partner og AI-ansvarlig (anonymiseret)',
    },
    image: boersen,
    logo: 'https://placehold.co/160x80/FFE0D8/C03626?text=Anonymous',
    services: ['AI Discovery & Konsulentbistand', 'AI-agenter'],
  },
  {
    id: 2,
    slug: 'ai-kompetenceloeft-konsulenthus',
    title: 'AI Discovery og udvikling af AI-assistenter',
    company: 'Managementkonsulenthus (anonymiseret)',
    industry: 'Ledelsesrådgivning',
    teaser: 'AI-kompetenceløft for 40+ medarbejdere med kurser, ChatGPT-træning og AI-assistenter.',
    metrics: [
      'AI-assistenter opsat, testet og justeret',
      '40+ medarbejdere opkvalificeret i AI',
      'Interne superbrugere trænet og klar retning for næste skridt',
    ],
    challenge:
      'Virksomheden ønskede at styrke AI-kompetencen i hele organisationen, gøre teknologien relevant i konsulenternes hverdag og skabe internt ejerskab til at udvikle og vedligeholde AI-assistenter.',
    solution: [
      'Flerstrenget AI-kompetenceforløb med generelle kurser og tematiserede mini-kurser',
      'Praktisk ChatGPT-træning skræddersyet til konsulentrollen (notatskrivning, analyse, rapporter, procesfacilitering)',
      'Opsætning og tilpasning af AI-assistenter samt træning af interne superbrugere',
    ],
    results: [
      'AI-assistenter sat i drift og tilpasset på baggrund af praksistests',
      'Alle 40+ medarbejdere har et højere AI-kompetenceniveau og praksisnære værktøjer',
      'Interne superbrugere driver videreudvikling og der er en klar retning for næste skridt',
    ],
    quote: {
      text: 'AICE gjorde AI relevant og konkret for vores konsulenter. Vi har fået et fælles sprog og praksisnære værktøjer, der styrker både vores rådgivning og interne effektivitet.',
      author: 'Partner (anonymiseret)',
    },
    image: consulting,
    logo: 'https://placehold.co/160x80/FFE0D8/C03626?text=Anonymous',
    services: [
      'Generelle AI-kurser',
      'Tematiserede mini-kurser',
      'Praktisk træning i ChatGPT',
      'Opsætning af AI-assistenter',
      'Træning af interne superbrugere',
      'Tilpasset undervisningsmateriale og øvelser',
    ],
  },
  {
    id: 3,
    slug: 'ai-discovery-ledelse-admin',
    title: 'AI Discovery for ledelse og administration',
    company: 'Kreativt bureau (anonymiseret)',
    industry: 'Kreativt bureau / kommunikation og design',
    teaser: 'Praksisnær AI-kompetenceopbygning for ledelse og administration med køreplan og assistenter.',
    metrics: [
      'AI-køreplan med prioriterede anvendelsescases',
      '2 anvendelsescases sat i gang',
      'AI-assistenter opsat og testet',
      '5 medarbejdere kompetenceudviklet',
    ],
    challenge:
      'Organisationen ville bruge AI som strategisk løftestang i ledelse og administration, men havde begrænset erfaring og brug for en konkret, praksisnær tilgang.',
    solution: [
      'Workshops og praktisk ChatGPT-træning målrettet ledelse, salg og administration',
      'Opsætning af de første AI-assistenter og tilpasning til hverdagsopgaver',
      'AI-køreplan med prioriterede anvendelsescases og igangsættelse af de to vigtigste',
    ],
    results: [
      'AI-køreplan på plads med konkrete anvendelsescases',
      '2 initiativer sat i gang og AI-assistenter testet',
      'Medarbejdere har fået en nærværende, brugbar tilgang til AI i praksis',
    ],
    quote: {
      text: 'AICE har gjort AI forståeligt, nærværende og brugbart for os i praksis. Vi har allerede sat konkrete initiativer i gang og ser et klart potentiale i vores hverdag.',
      author: 'Leder (anonymiseret)',
    },
    image: creativeAgency,
    logo: 'https://placehold.co/160x80/FFE0D8/C03626?text=Anonymous',
    services: [
      'AI-køreplan og anvendelsescases',
      'Workshops og praktisk ChatGPT-træning',
      'Opsætning af AI-assistenter',
      'Undervisning og løbende sparring',
    ],
  },
  {
    id: 4,
    slug: 'ai-kompetenceloeft-ingenioer',
    title: 'AI kompetenceløft for rådgivende ingeniør',
    company: 'Rådgivende ingeniør (anonymiseret)',
    industry: 'Rådgivende ingeniører',
    teaser: 'Ledelsesforankret AI-opstart med PrivateGPT, assistenter og heldagsworkshop for 25+ medarbejdere.',
    metrics: [
      '25+ medarbejdere opkvalificeret og i gang med AI',
      'AI-assistenter opsat i PrivateGPT',
      'Ledelsen klædt på til videre udvikling',
      'Stærk fremdrift efter første workshop',
    ],
    challenge:
      'Ledelsen ville forstå AI og afsøge anvendelser i rådgivning, mens organisationen var nysgerrig men skeptisk; der var behov for en tryg, struktureret introduktion med fokus på ansvarlig brug.',
    solution: [
      'Strategisk indflyvning for ledelsen om teknologi, muligheder og governance',
      'Heldagsworkshop for alle medarbejdere med praktisk undervisning i PrivateGPT',
      'Opsætning af AI-assistenter tilpasset ingeniørernes arbejdsopgaver og træning af interne ressourcepersoner',
    ],
    results: [
      'Alle medarbejdere kom i gang med AI gennem praksisnære øvelser',
      'PrivateGPT-assistenter sat op og tilpasset rådgivningsopgaver',
      'Ledelsen har ejerskab og en struktureret plan for videre udrulning',
    ],
    quote: {
      text: 'AICE gav os en struktureret og praksisnær indgang til AI. Vi gik fra tvivl til handling og har nu alle medarbejdere godt i gang med at bruge AI i hverdagen.',
      author: 'Partner (anonymiseret)',
    },
    image: cranes,
    logo: 'https://placehold.co/160x80/FFE0D8/C03626?text=Anonymous',
    services: [
      'Ledelsesbriefing og strategisk afklaring',
      'Heldagsworkshop for medarbejdere',
      'Træning i PrivateGPT',
      'Opsætning af AI-assistenter',
      'Træning af interne ressourcepersoner',
    ],
  },
  {
    id: 5,
    slug: 'ai-discovery-management-consulting',
    title: 'AI Discovery for ledelsesrådgivning',
    company: 'Managementkonsulenthus (anonymiseret)',
    industry: 'Ledelsesrådgivning',
    teaser: 'AI Discovery-workshop, køreplan og uddannelsesdag med første assistent i drift.',
    metrics: [
      'AI-køreplan med prioriterede assistenter og anvendelsescases',
      'Uddannelsesdag gennemført for hele organisationen',
      'Første AI-assistent sat i drift',
      'Intern ressource sat i spil til videre AI-udvikling',
    ],
    challenge:
      'Organisationen ville sætte AI i system med fælles retning og praktiske kompetencer, uden at spilde konsulenters tid. Der var behov for ejerskab på tværs af ledelse og medarbejdere.',
    solution: [
      'AI Discovery-workshop for ledelsen og nøglepersoner med udvikling af køreplan',
      'Uddannelsesdag for alle medarbejdere med praktisk ChatGPT-træning',
      'Opsætning af første AI-assistent og overdragelse til intern ressource (studentermedhjælper) for videre udvikling',
    ],
    results: [
      'AI-køreplan og rammer på plads med tydelig retning',
      'Første assistent i drift og intern kapacitet til at bygge videre',
      'Bred opbakning og interesse i organisationen',
    ],
    quote: {
      text: 'Forløbet gav os både overblik og konkrete værktøjer til at komme i gang. Vi er godt på vej med både retning og ressourcer til at udvikle videre.',
      author: 'Partner (anonymiseret)',
    },
    image: management,
    logo: 'https://placehold.co/160x80/FFE0D8/C03626?text=Anonymous',
    services: [
      'AI Discovery-workshop',
      'AI-køreplan',
      'Uddannelsesdag for medarbejdere',
      'Opsætning af AI-assistent',
      'Skræddersyet træningsmateriale og overdragelse',
    ],
  },
  {
    id: 6,
    slug: 'ai-inspiration-bestyrelseskvinder',
    title: 'AI inspirationsforløb for bestyrelsesarbejde',
    company: 'Bestyrelseskvinder Midt',
    industry: 'Netværk & bestyrelsesudvikling',
    teaser:
      'Inspirationsoplæg og praktisk AI-træning målrettet professionelt bestyrelsesarbejde.',
    metrics: [
      'Øget forståelse for AI’s rolle i bestyrelsesarbejde',
      'Konkrete eksempler og praktiske øvelser',
      'Stærk feedback og efterspørgsel på opfølgning',
    ],
    challenge:
      'Bestyrelseskvinder Midt ønskede at give medlemmerne et praksisnært indblik i, hvordan AI kan bruges strategisk og operativt i bestyrelsesarbejdet – både til analyse, mødeforberedelse og beslutningskvalitet.',
    solution: [
      'AI inspirationsoplæg med eksempler på bedste praksis og målrettede demoer',
      'Introduktion til ChatGPT og undervisning i god promptteknik',
      'Praktiske øvelser i mødeforberedelse, dokumentanalyse og strategisk sparring',
      'AI cheat sheet og metoder til videre brug i bestyrelsesarbejdet',
    ],
    results: [
      'Deltagerne gik fra inspiration til konkret handling med praktiske redskaber',
      'Styrket forståelse for AI’s potentiale i bestyrelseslokalet',
      'Høj tilfredshed og efterspørgsel efter videre træning og opfølgning',
    ],
    quote: {
      text:
        'AICE formåede at gøre AI relevant og praksisnær i det strategiske bestyrelsesarbejde. Vi fik både indsigt og værktøjer, vi kan anvende med det samme, for derigennem at højne kvaliteten af vores arbejde.',
      author:
        'Anna Marie Hejlsberg, Bestyrelsesmedlem og regionsbestyrelsesleder i Bestyrelseskvinder Midt',
    },
    image: board,
    logo: bestyrelseskvinderLogo,
    services: [
      'AI inspirationsoplæg',
      'Demoeksempler målrettet bestyrelser',
      'Undervisning i promptteknik',
      'AI cheat sheet til bestyrelsesarbejdet',
      'Interaktivt oplæg og øvelser',
    ],
  },

  {
    id: 7,
    slug: 'ai-inspiration-b2b-salg',
    title: 'AI inspiration for sælgere',
    company: 'Global B2B salgsteam (anonymiseret)',
    industry: 'Teknologi og fiberinfrastruktur',
    teaser: '½ dags AI-inspirationsworkshop for salgsteam med cases, prompts og Copilot.',
    metrics: [
      '25 sælgere og ledere engageret',
      'Meget positive evalueringer',
      'Øget forståelse for AI i B2B salg',
      'Klarere fælles sprog om AI internt',
    ],
    challenge:
      'Salgsteamet ville se, hvordan AI kan styrke kommerciel kommunikation, salgsforberedelse og kundeopfølgning, uden at gå på kompromis med professionalisme og datasikkerhed.',
    solution: [
      '½ dags AI-inspirationsworkshop med eksempler på bedste praksis og salgsrelevante demoer',
      'Praktiske øvelser i promptudformning og brug af Copilot på realistiske salgscases',
      'Dialog og erfaringsudveksling om tilbud, mødeforberedelse og kundeopfølgning',
    ],
    results: [
      'Positiv respons og høje evalueringer fra 25 deltagere',
      'Skarpere forståelse af AI’s rolle i salgsarbejde før, under og efter kundemøder',
      'Konkrete metoder og inspiration til at videreudvikle egne værktøjer og arbejdsgange',
    ],
    quote: {
      text: 'Workshoppen viste os, hvordan AI kan styrke både vores salgsproces og relationer til kunderne – og gav os konkrete metoder, vi kunne tage i brug med det samme.',
      author: 'Salgschef (anonymiseret)',
    },
    image: sales,
    logo: 'https://placehold.co/160x80/FFE0D8/C03626?text=Anonymous',
    services: [
      'AI inspirationsworkshop (½ dag)',
      'Salgsrelevante demoer',
      'Praktisk prompttræning',
      'Træningsmateriale til internt brug',
      'Gruppeøvelser og erfaringsudveksling',
    ],
  },
  {
    id: 8,
    slug: 'ai-strategi-institut',
    title: 'AI-strategi for viden- og serviceorganisation',
    company: 'Viden- og serviceinstitut (anonymiseret)',
    industry: 'Rådgivning og analyse',
    teaser: 'Fremadskuende AI-strategi der binder forskning, forretning og drift sammen.',
    metrics: [
      'Godkendt AI-strategi på direktionsniveau',
      'Visuel AI-vision som cirkelmodel',
      'Kortlagt AI-aktiviteter på tværs af enheder',
    ],
    challenge:
      'Organisationen havde mange AI-tiltag i gang, men manglede en samlet vision og styring på tværs af divisioner, funktioner og ledelseslag.',
    solution: [
      'Strategiske interviews og samskabelsesworkshops med kerneteam og direktion',
      'Udvikling af fremadskuende AI-vision og cirkelbaseret visualisering',
      'Kortlægning af igangværende AI-aktiviteter og prioriterede strategiske temaer',
      'Iterativ strategiudvikling med løbende feedback og godkendelse i direktionen',
    ],
    results: [
      'Samlet AI-strategi godkendt af adm. direktør og klar til udrulning',
      'Fælles sprog og retning for AI på tværs af organisationen',
      'Overblik over initiativer og klar styringsmodel for skalering',
    ],
    quote: {
      text: 'Vi havde brug for et samlet blik på AI som både pegede langt frem og hjalp os med de valg vi skal træffe nu. Forløbet gav os en klar vision, et struktureret overblik over indsatser og en strategi som er forankret i direktionen. Det gør det langt lettere at prioritere og arbejde systematisk videre med AI.',
      author: 'Adm. direktør (anonymiseret)',
    },
    image: knowledge,
    logo: 'https://placehold.co/160x80/FFE0D8/C03626?text=Anonymous',
    services: [
      'AI strategiudvikling',
      'Strategiske interviews og workshops',
      'Visualisering af AI vision',
      'Kortlægning af AI initiativer',
    ],
  },
  {
    id: 9,
    slug: 'ai-emailagent-kundeservice',
    title: 'AI-emailagent til kundeservice',
    company: 'Værdihåndteringsvirksomhed (anonymiseret)',
    industry: 'Financial services',
    teaser: 'AI-drevet emailagent der skriver svarudkast og sikrer ensartet tone på tværs af kundeserviceteamet.',
    metrics: [
      'Markant hurtigere sagsbehandling',
      'Ensartet tone og kommunikation på tværs af teamet',
      'Emailagent sat i drift med human-in-the-loop',
    ],
    challenge:
      'Kundeserviceteamet håndterede store mængder emails med varierende svar og tone på tværs af medarbejdere. Viden om produkter, politikker og standardsvar var spredt i systemer og ikke let tilgængeligt, hvilket gjorde det svært at sikre ensartet og korrekt kommunikation.',
    solution: [
      'Udvikling af AI-emailagent integreret i Outlook med Power Automate og Copilot Studio',
      'Opbygning af vidensbase med produktinformation, tone of voice og scenarie-baserede retningslinjer',
      'Human-in-the-loop proces hvor agenten skriver udkast som medarbejderen gennemgår og sender',
      'Testdag med kundeserviceteamet for at indsamle feedback og justere løsningen',
    ],
    results: [
      'Emailagent sat i drift som skriver svarudkast baseret på virksomhedens vidensbase',
      'Ensartet tone og kvalitet på tværs af kundeserviceteamet',
      'Betydeligt hurtigere behandling af standardhenvendelser med øget medarbejdertilfredshed',
      'Fælles vidensbase der sikrer korrekte og opdaterede svar',
    ],
    image: customerService,
    logo: 'https://placehold.co/160x80/FFE0D8/C03626?text=Anonymous',
    services: [
      'AI Discovery & Konsulentbistand',
      'AI-agenter',
      'Vidensbase-strukturering',
      'Integration med Microsoft 365',
      'Testdag og medarbejdertræning',
    ],
  },
];

const CaseCard = ({ item }) => {
  const navigate = useNavigate();

  const handleOpenCase = () => {
    navigate(`/kundecases/${item.slug}`);
  };

  return (
    <div
      style={caseCard}
      onClick={handleOpenCase}
      role="button"
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0 12px 28px rgba(154, 45, 32, 0.5)';
        e.currentTarget.style.transform = 'translateY(-2px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = '0 6px 18px rgba(0,0,0,0.05)';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleOpenCase();
        }
      }}
    >
      <div style={caseImage} aria-label={item.title}>
        {item.image ? (
          <img
            src={item.image}
            alt={item.title}
            style={caseImageImg}
            onError={(e) => {
              if (e.currentTarget.src !== anonymous) {
                e.currentTarget.src = anonymous;
              }
            }}
          />
        ) : (
          'Billede'
        )}
      </div>
      <div style={caseIndustryTag}>{item.industry}</div>
      <h3 style={{ margin: '1rem 0 0.5rem', fontSize: '1.25rem' }}>{item.title}</h3>
      <p style={caseTeaser}>{item.teaser}</p>
    </div>
  );
};

const Kundecases = () => {
  return (
    <div style={pageStyle}>
      <SeoHead
        title="AICE Kundecases | Resultater med AI-agenter og rådgivning"
        description="Læs kundecases fra AICE om AI Discovery, AI-agenter og implementeringer der sparer tid og løfter kvaliteten i vidensvirksomheder."
        canonicalPath="/kundecases"
      />
      <section style={heroSection}>
        <h1 style={heroHeading}>AICE kundecases og resultater</h1>
        <p style={heroText}>
          Se hvordan vi hjælper virksomheder med at gøre AI til en konkurrencefordel. Hver case viser,
          hvordan vi identificerer muligheder, implementerer løsninger og sikrer forankring hos kunderne.
        </p>
      </section>

      <section style={casesSection}>
        <div style={casesGrid}>
          {caseData.map((item) => (
            <CaseCard key={item.id} item={item} />
          ))}
        </div>
      </section>
    </div>
  );
};

export const CaseDetail = () => {
  const { caseId } = useParams();
  const navigate = useNavigate();
  const customerCase = caseData.find(
    (item) => item.slug === caseId || String(item.id) === String(caseId),
  );

  if (!customerCase) {
    return (
      <div style={pageStyle}>
        <section style={heroSection}>
          <h2 style={heroHeading}>Case ikke fundet</h2>
          <p style={heroText}>Vi kunne ikke finde den ønskede case.</p>
          <button type="button" style={backLink} onClick={() => navigate('/kundecases')}>
            Tilbage til kundecases
          </button>
        </section>
      </div>
    );
  }

  return (
    <div style={pageStyle}>
      <SeoHead
        title={`${customerCase.title} | AICE kundecase`}
        description={customerCase.teaser}
        canonicalPath={`/kundecases/${customerCase.slug || customerCase.id}`}
      />
      <section style={detailHeader}>
        <p style={breadcrumb}>
          <button type="button" style={backLink} onClick={() => navigate('/kundecases')}>
            ← Alle kundecases
          </button>
        </p>
        <p style={caseMeta}>{customerCase.industry}</p>
        <h1 style={detailHeading}>{customerCase.title}</h1>
        <p style={heroText}>{customerCase.teaser}</p>
        <div style={metricsRow}>
          {customerCase.metrics?.map((metric) => (
            <div key={metric} style={metricTag}>{metric}</div>
          ))}
        </div>
      </section>

      <section style={detailBody}>
      <div style={detailMain}>
        <div style={detailBlock}>
          <h3 style={detailBlockTitle}>Udfordring</h3>
          <p style={detailText}>{customerCase.challenge}</p>
        </div>

          <div style={detailBlock}>
            <h3 style={detailBlockTitle}>Løsning</h3>
            <ul style={detailList}>
              {customerCase.solution?.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>

          <div style={detailBlock}>
            <h3 style={detailBlockTitle}>Resultater</h3>
            <ul style={detailList}>
              {customerCase.results?.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>

          {customerCase.quote && (
            <div style={quoteBlock}>
              <p style={quoteText}>"{customerCase.quote.text}"</p>
              <p style={quoteAuthor}>— {customerCase.quote.author}</p>
            </div>
          )}
        </div>

        <aside style={detailSidebar}>
          <div style={sidebarCard}>
            <h4 style={sidebarTitle}>Virksomhed</h4>
            <p style={sidebarText}>{customerCase.company}</p>
            <p style={{ ...sidebarText, marginTop: '0.25rem' }}>{customerCase.industry}</p>
          </div>
          {customerCase.services?.length ? (
            <div style={sidebarCard}>
              <h4 style={sidebarTitle}>Leverancer</h4>
              <ul style={sidebarList}>
                {customerCase.services.map((service) => (
                  <li key={service}>{service}</li>
                ))}
              </ul>
            </div>
          ) : null}
        </aside>
      </section>
    </div>
  );
};

export default Kundecases;

const pageStyle = {
  backgroundColor: '#FFF9F8',
  minHeight: '100vh',
  padding: '4rem clamp(1rem, 5vw, 4rem)',
};

const heroSection = {
  maxWidth: '820px',
  margin: '0 auto 3rem',
  textAlign: 'center',
};

const heroHeading = {
  fontSize: '3rem',
  marginBottom: '1rem',
  color: '#111',
};

const heroText = {
  fontSize: '1.2rem',
  color: '#333',
  lineHeight: 1.6,
};

const casesSection = {
  padding: '40px 0',
};

const casesGrid = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '1.5rem',
  justifyContent: 'center',
};

const caseCard = {
  flex: '1 1 280px',
  maxWidth: '320px',
  background: '#fff',
  borderRadius: '12px',
  border: '1px solid #f1d5cf',
  padding: ' 1.5rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: '0.75rem',
  boxShadow: '0 6px 18px rgba(0,0,0,0.05)',
  transition: 'box-shadow 0.2s ease, transform 0.2s ease',
  cursor: 'pointer',
};

const caseImage = {
  width: 'calc(100% + 3rem)',
  height: '160px',
  background: '#FDF0EC',
  borderRadius: '12px 12px 0 0',
  marginLeft: '-1.5rem',
  marginRight: '-1.5rem',
  marginTop: '-1.5rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#C03626',
  fontWeight: 600,
  overflow: 'hidden',
};

const caseImageImg = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
};

const caseIndustryTag = {
  marginTop: '0.5rem',
  borderRadius: '999px',
  background: '#FFE0D8',
  color: '#C03626',
  fontWeight: 600,
  padding: '0.25rem 0.85rem',
  fontSize: '0.85rem',
};

const caseTeaser = {
  color: '#4a4a4a',
  margin: 0,
  minHeight: '48px',
  lineHeight: 1.5,
};


const breadcrumb = {
  margin: 0,
  color: '#666',
  fontSize: '0.95rem',
};

const caseMeta = {
  color: '#C03626',
  fontWeight: 700,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  fontSize: '0.9rem',
  margin: '0.25rem 0 0.5rem',
};

const detailHeading = {
  fontSize: '2.5rem',
  margin: '0 0 0.75rem',
  color: '#111',
};

const metricsRow = {
  display: 'flex',
  gap: '0.5rem',
  flexWrap: 'wrap',
  marginTop: '1rem',
};

const metricTag = {
  background: '#FFE8E1',
  color: '#C03626',
  padding: '0.35rem 0.75rem',
  borderRadius: '999px',
  fontWeight: 600,
  fontSize: '0.95rem',
};

const detailHeader = {
  maxWidth: '1200px',
  margin: '0 auto 1.5rem',
};

const detailBody = {
  maxWidth: '1200px',
  margin: '0 auto',
  display: 'grid',
  gridTemplateColumns: '2fr 1fr',
  gap: '1.25rem',
  alignItems: 'start',
};

const detailMain = {
  background: '#fff',
  border: '1px solid #f1d5cf',
  borderRadius: '12px',
  padding: '1.5rem',
  boxShadow: '0 6px 18px rgba(0,0,0,0.05)',
};

const detailBlock = {
  marginBottom: '1.5rem',
};

const detailBlockTitle = {
  margin: '0 0 0.5rem',
  fontSize: '1.25rem',
};

const detailText = {
  margin: 0,
  lineHeight: 1.6,
  color: '#333',
};

const detailList = {
  margin: '0.5rem 0 0 1.25rem',
  color: '#333',
  lineHeight: 1.6,
};

const quoteBlock = {
  borderLeft: '4px solid #C03626',
  paddingLeft: '1rem',
  marginTop: '1.5rem',
};

const quoteText = {
  fontSize: '1.1rem',
  fontStyle: 'italic',
  margin: 0,
};

const quoteAuthor = {
  margin: '0.35rem 0 0',
  color: '#444',
  fontWeight: 600,
};

const detailSidebar = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
};

const sidebarCard = {
  background: '#fff',
  border: '1px solid #f1d5cf',
  borderRadius: '12px',
  padding: '1rem',
  boxShadow: '0 6px 18px rgba(0,0,0,0.05)',
};

const sidebarTitle = {
  margin: '0 0 0.35rem',
  fontSize: '1.05rem',
};

const sidebarText = {
  margin: 0,
  color: '#333',
};

const sidebarList = {
  margin: '0.5rem 0 0 1.1rem',
  color: '#333',
  lineHeight: 1.6,
};

const backLink = {
  background: 'none',
  border: 'none',
  color: '#C03626',
  fontWeight: 600,
  cursor: 'pointer',
  padding: 0,
  textDecoration: 'underline',
};
